export const SettingsActionTypes = {
  SET_PAGE_TITLE: "SET_PAGE_TITLE",
  TOGGLE_NAV_DRAWER: "TOGGLE_NAV_DRAWER",
  SET_NAV_DRAWER: "SET_NAV_DRAWER",
  SET_SNACKBAR: "SET_SNACKBAR",
  DISMISS_SNACKBAR: "DISMISS_SNACKBAR",
};
